export default __webpack_public_path__ + "images/loggedout/shapes/star-1c06ab55a0d00c0ebfbfefa233bd06a7.svg";